const pathDraw =
  "M22.8563 31.8562C21.8344 32.8781 20.1656 32.8781 19.1437 31.8562L13.1437 25.8562C12.1219 \
  24.8344 12.1219 23.1656 13.1437 22.1437C14.1656 21.1219 15.8344 21.1219 16.8563 22.1437L21 \
  26.2875L31.1438 16.1437C32.1656 15.1219 33.8344 15.1219 34.8562 16.1437C35.8781 17.1656 \
  35.8781 18.8344 34.8562 19.8563L22.8563 31.8562ZM48 24C48 37.2562 37.2562 48 24 48C10.7438 \
  48 0 37.2562 0 24C0 10.7438 10.7438 0 24 0C37.2562 0 48 10.7438 48 24ZM24 4.5C13.2281 4.5 4.5 \
  13.2281 4.5 24C4.5 34.7719 13.2281 43.5 24 43.5C34.7719 43.5 43.5 34.7719 43.5 24C43.5 13.2281 \
  34.7719 4.5 24 4.5Z";

export const CircleCheck = ({ fillColor = "#46BB95", inline = false }) => {
  const classes = inline ? "verified inline" : "verified";

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none">
      <path fill={fillColor} d={pathDraw} />
    </svg>
  );
};
